// extracted by mini-css-extract-plugin
module.exports = {"funderline":"funderline__19Hn2"};